<template>
  <div class="page-wrap">
    <el-card class="page-card--full">
    <div class="page-card-body" ref="pageRoot">
      <div ref="queryBar" style="display:flex;gap:12px;align-items:center;flex-wrap:wrap;">
        <el-button type="primary" @click="openCreate">新增菜单</el-button>
      </div>

      <el-table :data="list" :height="tableHeight" style="width:100%;" size="small" row-key="id">
        <el-table-column prop="name" label="名称" />
        <el-table-column prop="type" label="类型" width="120">
          <template slot-scope="s">{{ typeText(s.row.type) }}</template>
        </el-table-column>
        <el-table-column prop="path" label="路径" />
        <el-table-column prop="perms" label="权限标识" width="160" />
        <el-table-column label="操作" width="200">
          <template slot-scope="s">
            <el-button type="text" @click="openEdit(s.row)">编辑</el-button>
            <el-button type="text" style="color:#ef4444" @click="remove(s.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog :title="form.id?'编辑菜单':'新增菜单'" :visible.sync="dlg" width="520px">
      <el-form :model="form" label-width="110px">
        <el-form-item label="父级ID"><el-input v-model="form.parentId" placeholder="根节点留空" /></el-form-item>
        <el-form-item label="名称"><el-input v-model="form.name" /></el-form-item>
        <el-form-item label="类型">
          <el-select v-model="form.type" style="width:100%">
            <el-option :value="1" label="目录" />
            <el-option :value="2" label="菜单" />
            <el-option :value="3" label="按钮" />
          </el-select>
        </el-form-item>
        <el-form-item label="路由 path"><el-input v-model="form.path" placeholder="如 /biz/order" /></el-form-item>
        <el-form-item label="组件 component"><el-input v-model="form.component" placeholder="如 views/biz/order" /></el-form-item>
        <el-form-item label="图标"><el-input v-model="form.icon" /></el-form-item>
        <el-form-item label="权限 perms"><el-input v-model="form.perms" placeholder="如 biz:order" /></el-form-item>
        <el-form-item label="排序"><el-input-number v-model="form.sort" :min="0" /></el-form-item>
        <el-form-item label="显示">
          <el-select v-model="form.visible" style="width:100%">
            <el-option :value="1" label="显示" />
            <el-option :value="0" label="隐藏" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="form.status" style="width:100%">
            <el-option :value="1" label="启用" />
            <el-option :value="0" label="停用" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dlg=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </span>
    </el-dialog>
    </el-card>
  </div>
</template>

<script>
import request from '../../utils/request'
import tableAutoHeight from '../../mixins/tableAutoHeight'

export default {
  name: 'SysMenu',
  mixins: [tableAutoHeight],
  data() {
    return {
      list: [],
      dlg: false,
      saving: false,
      form: { id: '', parentId: '', name: '', type: 2, path: '', component: '', icon: '', perms: '', sort: 0, visible: 1, status: 1 }
    }
  },
  created() {
    this.load()
  },
  methods: {
    typeText(t) {
      if (t === 1) return '目录'
      if (t === 2) return '菜单'
      if (t === 3) return '按钮'
      return ''
    },
    async load() {
      this.list = await request.get('/admin/api/sys/menu/tree')
    },
    openCreate() {
      this.form = { id: '', parentId: '', name: '', type: 2, path: '', component: '', icon: '', perms: '', sort: 0, visible: 1, status: 1 }
      this.dlg = true
    },
    openEdit(row) {
      this.form = { ...row }
      this.dlg = true
    },
    async save() {
      if (this.saving) return
      this.saving = true
      try {
        if (this.form.id) {
          await request.put('/admin/api/sys/menu/' + this.form.id, this.form)
        } else {
          await request.post('/admin/api/sys/menu', this.form)
        }
        this.$message.success('已保存')
        this.dlg = false
        await this.load()
      } finally {
        this.saving = false
      }
    },
    async remove(row) {
      await this.$confirm('确认删除该菜单？若有子菜单需先删除子菜单。', '提示', { type: 'warning' })
      await request.delete('/admin/api/sys/menu/' + row.id)
      this.$message.success('已删除')
      await this.load()
    }
  }
}
</script>

